<li class="dropdown">
  <a class="nav-link dropdown-toggle arrow-none px-2" data-bs-toggle="dropdown" href="javascript:void(0);"
    role="button" aria-haspopup="false" aria-expanded="false" [matTooltip]="'layout.header.language' | translate">
    <i class="ri-global-line font-22"></i>
  </a>
  <div class="dropdown-menu dropdown-menu-end">
    @for (locale of locales; track locale) {
    <a class="dropdown-item" href="javascript:void(0);" [class.active]="locale === current" (click)="select(locale)">
      {{ labels[locale] }}
    </a>
    }
  </div>
</li>
